var _filter, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 1920 1920",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    type: "matrix"
  }))), /*#__PURE__*/React.createElement("mask", {
    height: 20000,
    width: 20000,
    y: -10000,
    x: -10000,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    "mask-type": "alpha",
    id: "i1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#i0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 1",
    keyTimes: "0; 0.022222; 0.177778; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.01,1187.835)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1099.01 1187.835; 989.155 1114.015; 947.01 981.835; 947.01 981.835",
    keyTimes: "0; 0.166667; 0.277778; 1",
    keySplines: "0.506 0 0.783 0.496; 0.337 0.495 0.576 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1.1 1.1; 0.95 0.95; 1.02 1.02; 0.98 0.98; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 0.444444; 0.511111; 0.555555; 0.611111; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,346.916,346.917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1e71ed",
    d: "M346.667,0C346.667,191.458,191.459,346.667,0,346.667C-191.458,346.667,-346.667,191.458,-346.667,0C-346.667,-191.459,-191.458,-346.666,0,-346.666C191.459,-346.666,346.667,-191.459,346.667,0Z"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i3"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1087.199,1174.507)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1087.199 1174.507; 1087.199 1174.507; 1027.199 504.507; 1027.199 504.507",
    keyTimes: "0; 0.055556; 0.372222; 1",
    keySplines: "0 0 1 1; 0.252 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-30.771,-30.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,30.771,30.772)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9aa3c4",
    d: "M30.522,-0.001C30.522,16.856,16.856,30.522,0,30.522C-16.857,30.522,-30.522,16.856,-30.522,-0.001C-30.522,-16.857,-16.857,-30.522,0,-30.522C16.856,-30.522,30.522,-16.857,30.522,-0.001Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i4"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.638,1189.457)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1098.638 1189.457; 1098.638 1189.457; 788.638 547.457; 788.638 547.457",
    keyTimes: "0; 0.055556; 0.394445; 1",
    keySplines: "0 0 1 1; 0.292 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-33.515,-41.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,33.515,41.664)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9aa3c4",
    d: "M28.859,29.054C28.859,29.054,10.733,39.519,10.733,39.519C7.451,41.414,3.255,40.289,1.36,37.008C1.36,37.008,-31.37,-19.683,-31.37,-19.683C-33.265,-22.964,-32.14,-27.16,-28.859,-29.054C-28.859,-29.054,-10.732,-39.52,-10.732,-39.52C-7.451,-41.414,-3.255,-40.29,-1.36,-37.009C-1.36,-37.009,31.37,19.682,31.37,19.682C33.265,22.964,32.14,27.159,28.859,29.054Z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i5"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067.471,1180.071)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1067.471 1180.071; 1067.471 1180.071; 529.471 736.071; 529.471 736.071",
    keyTimes: "0; 0.055556; 0.338889; 1",
    keySplines: "0 0 1 1; 0.174 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-47.326,-47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,47.325,47.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47ad7d",
    d: "M-17.558,-36.37C-17.558,-36.37,-13.481,-34.987,-13.481,-34.987C-8.858,-33.419,-3.759,-34.227,0.154,-37.147C0.154,-37.147,3.605,-39.722,3.605,-39.722C13.458,-47.075,27.467,-39.938,27.31,-27.644C27.31,-27.644,27.255,-23.339,27.255,-23.339C27.192,-18.457,29.535,-13.857,33.521,-11.038C33.521,-11.038,37.037,-8.552,37.037,-8.552C47.075,-1.453,44.615,14.074,32.875,17.724C32.875,17.724,28.763,19.002,28.763,19.002C24.101,20.451,20.452,24.102,19.003,28.764C19.003,28.764,17.724,32.876,17.724,32.876C14.075,44.616,-1.453,47.075,-8.552,37.037C-8.552,37.037,-11.039,33.522,-11.039,33.522C-13.858,29.536,-18.458,27.192,-23.339,27.255C-23.339,27.255,-27.645,27.309,-27.645,27.309C-39.938,27.466,-47.075,13.459,-39.722,3.605C-39.722,3.605,-37.146,0.154,-37.146,0.154C-34.226,-3.758,-33.419,-8.857,-34.987,-13.481C-34.987,-13.481,-36.37,-17.558,-36.37,-17.558C-40.318,-29.202,-29.202,-40.318,-17.558,-36.37Z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i6"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1074.624,1178.727)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1074.624 1178.727; 1074.624 1178.727; 446.624 934.727; 446.624 934.727",
    keyTimes: "0; 0.055556; 0.383333; 1",
    keySplines: "0 0 1 1; 0.273 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-42,-25.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,42,25.144)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707ba8",
    d: "M36.343,-18.872C36.343,-18.872,40.921,1.552,40.921,1.552C41.75,5.249,39.425,8.919,35.727,9.747C35.727,9.747,-28.148,24.066,-28.148,24.066C-31.845,24.894,-35.514,22.569,-36.344,18.872C-36.344,18.872,-40.922,-1.553,-40.922,-1.553C-41.75,-5.25,-39.425,-8.919,-35.728,-9.747C-35.728,-9.747,28.148,-24.066,28.148,-24.066C31.845,-24.894,35.514,-22.569,36.343,-18.872Z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i7"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1071.297,1171.159)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1071.297 1171.159; 1071.297 1171.159; 517.297 1177.159; 517.297 1177.159",
    keyTimes: "0; 0.055556; 0.388889; 1",
    keySplines: "0 0 1 1; 0.283 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-30.771,-30.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,30.771,30.771)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fac033",
    d: "M30.521,0C30.521,16.856,16.856,30.521,0,30.521C-16.857,30.521,-30.521,16.856,-30.521,0C-30.521,-16.856,-16.857,-30.521,0,-30.521C16.856,-30.521,30.521,-16.856,30.521,0Z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i8"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1081.471,1169.811)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1081.471 1169.811; 1081.471 1169.811; 529.471 1363.811; 529.471 1363.811",
    keyTimes: "0; 0.055556; 0.238889; 1",
    keySplines: "0 0 1 1; 0.189 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-47.326,-47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,47.325,47.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707ba8",
    d: "M-17.558,-36.37C-17.558,-36.37,-13.481,-34.987,-13.481,-34.987C-8.858,-33.42,-3.759,-34.227,0.154,-37.147C0.154,-37.147,3.605,-39.723,3.605,-39.723C13.458,-47.075,27.467,-39.938,27.31,-27.644C27.31,-27.644,27.255,-23.339,27.255,-23.339C27.192,-18.457,29.535,-13.857,33.521,-11.038C33.521,-11.038,37.037,-8.553,37.037,-8.553C47.075,-1.453,44.615,14.074,32.875,17.724C32.875,17.724,28.763,19.002,28.763,19.002C24.101,20.451,20.452,24.102,19.003,28.764C19.003,28.764,17.724,32.875,17.724,32.875C14.075,44.616,-1.453,47.075,-8.552,37.037C-8.552,37.037,-11.039,33.522,-11.039,33.522C-13.858,29.535,-18.458,27.192,-23.339,27.254C-23.339,27.254,-27.645,27.31,-27.645,27.31C-39.938,27.467,-47.075,13.459,-39.722,3.606C-39.722,3.606,-37.146,0.154,-37.146,0.154C-34.226,-3.759,-33.419,-8.857,-34.987,-13.481C-34.987,-13.481,-36.37,-17.558,-36.37,-17.558C-40.318,-29.202,-29.202,-40.318,-17.558,-36.37Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i9"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1086.148,1173.839)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1086.148 1173.839; 1086.148 1173.839; 1316.148 645.839; 1316.148 645.839",
    keyTimes: "0; 0.055556; 0.255556; 1",
    keySplines: "0 0 1 1; 0.229 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-77.856,-74.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,77.856,74.774)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 20,
    stroke: "#707ba8",
    d: "M-18.607,24.774C-27.856,12.719,-24.993,-5.238,-12.262,-15.006C0.468,-24.774,18.556,-22.893,27.805,-10.838C27.823,-10.815,27.839,-10.792,27.857,-10.77"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i10"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1095.413,1171.271)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1095.413 1171.271; 1095.413 1171.271; 1397.413 873.271; 1397.413 873.271",
    keyTimes: "0; 0.055556; 0.377778; 1",
    keySplines: "0 0 1 1; 0.263 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-47.326,-47.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,47.325,47.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9aa3c4",
    d: "M-17.558,-36.37C-17.558,-36.37,-13.481,-34.987,-13.481,-34.987C-8.858,-33.419,-3.758,-34.227,0.154,-37.147C0.154,-37.147,3.606,-39.722,3.606,-39.722C13.46,-47.075,27.467,-39.938,27.31,-27.644C27.31,-27.644,27.255,-23.339,27.255,-23.339C27.193,-18.457,29.537,-13.857,33.522,-11.038C33.522,-11.038,37.038,-8.552,37.038,-8.552C47.076,-1.453,44.617,14.074,32.877,17.724C32.877,17.724,28.763,19.002,28.763,19.002C24.101,20.451,20.452,24.102,19.003,28.764C19.003,28.764,17.724,32.876,17.724,32.876C14.075,44.616,-1.453,47.075,-8.551,37.037C-8.551,37.037,-11.037,33.522,-11.037,33.522C-13.857,29.536,-18.456,27.192,-23.338,27.255C-23.338,27.255,-27.644,27.31,-27.644,27.31C-39.937,27.466,-47.075,13.459,-39.721,3.606C-39.721,3.606,-37.146,0.155,-37.146,0.155C-34.226,-3.758,-33.418,-8.857,-34.987,-13.481C-34.987,-13.481,-36.37,-17.558,-36.37,-17.558C-40.318,-29.202,-29.202,-40.318,-17.558,-36.37Z"
  })))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i11"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1106.768,1189.936)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1106.768 1189.936; 1106.768 1189.936; 1420.768 1239.936; 1420.768 1239.936",
    keyTimes: "0; 0.055556; 0.238889; 1",
    keySplines: "0 0 1 1; 0.189 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-60.548,-78.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,60.548,78.82)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 15,
    stroke: "#de3f3f",
    d: "M-12.409,-41.32C8.345,-38.587,23.048,-18.302,20.162,3.615C17.276,25.533,-2.177,41.32,-22.93,38.586C-22.97,38.581,-23.009,38.576,-23.048,38.571"
  })))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i12"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1088.113,1187.051)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1088.113 1187.051; 1088.113 1187.051; 1314.113 1427.051; 1314.113 1427.051",
    keyTimes: "0; 0.055556; 0.255556; 1",
    keySplines: "0 0 1 1; 0.229 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-33.514,-41.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,33.514,41.664)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707ba8",
    d: "M28.859,29.055C28.859,29.055,10.732,39.52,10.732,39.52C7.451,41.414,3.255,40.29,1.361,37.009C1.361,37.009,-31.37,-19.681,-31.37,-19.681C-33.264,-22.964,-32.14,-27.159,-28.859,-29.053C-28.859,-29.053,-10.732,-39.519,-10.732,-39.519C-7.451,-41.414,-3.255,-40.29,-1.361,-37.008C-1.361,-37.008,31.37,19.683,31.37,19.683C33.264,22.964,32.14,27.16,28.859,29.055Z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i13"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.177778; 0.483333; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.601; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1088.545,1185.048)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.055556; 0.233333; 1",
    keySplines: "0 0 1 1; 0.174 0 0.33 1; 0 0 1 1",
    keyPoints: "0; 0; 1; 1",
    path: "M0 0 C-154.333 61 -279.667 201 -314 270",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-88.379,-84.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,88.378,84.131)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 20,
    stroke: "#9aa3c4",
    d: "M-25.635,34.132C-38.378,17.524,-34.433,-7.216,-16.894,-20.673C0.645,-34.131,25.563,-31.538,38.306,-14.931C38.306,-14.931,38.379,-14.837,38.379,-14.837"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.01,1187.835)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1099.01 1187.835; 989.155 1114.015; 947.01 981.835; 947.01 981.835",
    keyTimes: "0; 0.166667; 0.277778; 1",
    keySplines: "0.506 0 0.783 0.496; 0.337 0.495 0.576 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1.1 1.1; 0.95 0.95; 1.02 1.02; 0.98 0.98; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 0.444444; 0.511111; 0.555555; 0.611111; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i15"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0.2; 0.2; 0.2",
    keyTimes: "0; 0.022222; 0.177778; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.917,346.917)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "346.917 346.917; 346.917 346.917; 346.917 346.917; 346.917 346.917",
    keyTimes: "0; 0.166667; 0.272222; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1.48 1.48; 0.88 0.88; 0.88 0.88",
    keyTimes: "0; 0.333334; 0.611111; 1",
    keySplines: "0.67 0 0.33 1; 0.67 0 0.33 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,346.916,346.917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36ba3c",
    d: "M346.667,0C346.667,191.458,191.459,346.667,0,346.667C-191.458,346.667,-346.667,191.458,-346.667,0C-346.667,-191.459,-191.458,-346.666,0,-346.666C191.459,-346.666,346.667,-191.459,346.667,0Z"
  }))))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i14"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 1",
    keyTimes: "0; 0.022222; 0.177778; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.01,1187.835)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1099.01 1187.835; 989.155 1114.015; 947.01 981.835; 947.01 981.835",
    keyTimes: "0; 0.166667; 0.277778; 1",
    keySplines: "0.506 0 0.783 0.496; 0.337 0.495 0.576 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1.1 1.1; 0.95 0.95; 1.02 1.02; 0.98 0.98; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 0.444444; 0.511111; 0.555555; 0.611111; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,346.916,346.917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36ba3c",
    d: "M346.667,0C346.667,191.458,191.459,346.667,0,346.667C-191.458,346.667,-346.667,191.458,-346.667,0C-346.667,-191.459,-191.458,-346.666,0,-346.666C191.459,-346.666,346.667,-191.459,346.667,0Z"
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i1)",
    opacity: 0,
    id: "i16"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 0; 0",
    keyTimes: "0; 0.022222; 0.611111; 0.777778; 1",
    keySplines: "0.167 0 0.833 1; 0.167 0 0.833 1; 0.72 0 0.833 0.643; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56,440)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "56 440; 56 440; 1416 1228; 1416 1228",
    keyTimes: "0; 0.522222; 0.777778; 1",
    keySplines: "0 0 1 1; 0.72 0 0.833 0.788; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c9d3ef",
    fillOpacity: 0.3,
    d: "M211.999,-440C211.999,-440,-131.345,281.947,-480,280C-488.868,279.951,-136,648,-136,648C-136,648,519.646,568.072,483.999,-312C480.18,-406.283,211.999,-440,211.999,-440Z"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    opacity: 0,
    id: "i18"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 1",
    keyTimes: "0; 0.022222; 0.177778; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.01,1187.835)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1099.01 1187.835; 989.155 1114.015; 947.01 981.835; 947.01 981.835",
    keyTimes: "0; 0.166667; 0.277778; 1",
    keySplines: "0.506 0 0.783 0.496; 0.337 0.495 0.576 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1.1 1.1; 0.95 0.95; 1.02 1.02; 0.98 0.98; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 0.444444; 0.511111; 0.555555; 0.611111; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,346.916,346.917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1e71ed",
    d: "M346.667,0C346.667,191.458,191.459,346.667,0,346.667C-191.458,346.667,-346.667,191.458,-346.667,0C-346.667,-191.459,-191.458,-346.666,0,-346.666C191.459,-346.666,346.667,-191.459,346.667,0Z"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1099.01,1187.835)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "1099.01 1187.835; 989.155 1114.015; 947.01 981.835; 947.01 981.835",
    keyTimes: "0; 0.166667; 0.277778; 1",
    keySplines: "0.506 0 0.783 0.496; 0.337 0.495 0.576 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1.1 1.1; 0.95 0.95; 1.02 1.02; 0.98 0.98; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 0.444444; 0.511111; 0.555555; 0.611111; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.917,-346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i19"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1; 1",
    keyTimes: "0; 0.022222; 0.177778; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.916,346.917)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-99)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "-99; -99; 0; 0",
    keyTimes: "0; 0.166667; 0.333333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3s",
    begin: "0s",
    calcMode: "spline",
    values: "0.2 0.2; 0.2 0.2; 1 1; 1 1",
    keyTimes: "0; 0.166667; 0.333333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.033,-227.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,278.033,227.218)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 50,
    stroke: "#ffffff",
    d: "M-153.033,0.588"
  }, /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5166666666666667s",
    to: "M-153.033,0.588",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5333333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-152.937,0.684,-152.751,0.87",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.55s",
    to: "M-153.033,0.588C-153.033,0.588,-152.623,0.998,-151.856,1.765",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5666666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-152.043,1.578,-150.259,3.362",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5833333333333334s",
    to: "M-153.033,0.588C-153.033,0.588,-151.133,2.488,-147.852,5.769",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6s",
    to: "M-153.033,0.588C-153.033,0.588,-149.804,3.817,-144.498,9.123",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6166666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-147.935,5.686,-140.024,13.597",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6333333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-145.348,8.273,-134.204,19.417",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.65s",
    to: "M-153.033,0.588C-153.033,0.588,-141.77,11.851,-126.743,26.878",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6666666666666666s",
    to: "M-153.033,0.588C-153.033,0.588,-136.762,16.859,-117.241,36.381",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6833333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-129.547,24.075,-105.155,48.466",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7s",
    to: "M-153.033,0.588C-153.033,0.588,-118.552,35.069,-89.76,63.862",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7166666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-99.503,54.118,-70.143,83.479",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7333333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,-49.278,100.092,-45.46,96.274",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.75s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,-37.022,87.836,-15.888,66.702",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7666666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,-21.255,72.069,15.886,34.928",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7833333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,-3.804,54.618,45.459,5.355",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,13.48,37.334,70.141,-19.327",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8166666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,29.716,21.098,89.758,-38.944",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8333333333333334s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,44.732,6.082,105.154,-54.34",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.85s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,58.621,-7.807,117.24,-66.426",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8666666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,71.537,-20.723,126.742,-75.928",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8833333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,83.624,-32.81,134.204,-83.39",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,95.006,-44.192,140.023,-89.209",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9166666666666666s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,105.786,-54.972,144.497,-93.683",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9333333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,116.046,-65.232,147.851,-97.037",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.95s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,125.849,-75.035,150.258,-99.444",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9666666666666667s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,135.254,-84.44,151.855,-101.041",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9833333333333333s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.403,102.217,144.302,-93.488,152.75,-101.936",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1s",
    to: "M-153.033,0.588C-153.033,0.588,-51.404,102.218,-51.404,102.218C-51.404,102.218,153.032,-102.218,153.032,-102.218",
    attributeName: "d"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickAnimation);
export default __webpack_public_path__ + "static/media/greenTickAnimation.e37c99277c57a32bf8a968c1f39b7be6.svg";
export { ForwardRef as ReactComponent };